(function () {
	'use strict';
	$(() => {
		if ($('.custom-form').length === 0) {
			return false;
		}

		const formElement = document.querySelector('form.custom-form');

		$('.fileInput').change(function () {
			const filesAmount = this.files.length;
			const hasMultiple = filesAmount > 1;
			const labelText = !hasMultiple ? this.files[0].name : `${fhTranslate('files')}: ${filesAmount}`;
			if (filesAmount) {
				$(this).siblings('label').find('span.text').text(labelText);
			}
		});

		//Checkbox label expand
		$('.Checkbox-more').on('click', function (e) {
			e.preventDefault();
			$(this).siblings('.description').slideToggle();
			const expandText = $(this).text();
			$(this).toggleClass('open').text(expandText === fhTranslate('expand') ? fhTranslate('collapse') : fhTranslate('expand'));
		});

		// Validation functions
		const validateEmail = (email) => {
			const EMAIL_REGEXP =
				/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return email.match(EMAIL_REGEXP);
		};

		const validatePhone = (phone) => {
			const PHONE_REGEXP =
				/^[0-9+-\\(\\)\\ \\#]{1,15}$/;
			return phone.match(PHONE_REGEXP);
		};

		const validateNip = (nip) => {
			if (typeof nip !== 'string') {
				return false;
			}
			nip = nip.replace(/[\ \-]/gi, '');

			let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
			let sum = 0;
			let controlNumber = parseInt(nip.substring(9, 10));
			let weightCount = weight.length;
			for (let i = 0; i < weightCount; i++) {
				sum += (parseInt(nip.substr(i, 1)) * weight[i]);
			}

			return sum % 11 === controlNumber;
		};

		const validatePostalCode = (postal_code) => {
			if (typeof postal_code !== 'string')
				return false;

			return postal_code.match(/^\d{2}-\d{3}$/);
		};

		const validateFile = (files, extensions = '') => {
			const allowed_extensions = extensions.split(",");
			const isValid = Array.from(files).every((file) => {
				const type = file.type;
				const extension = file.name.split('.').reverse()[0].toLowerCase();
				if (extensions) {
					return allowed_extensions.includes('.' + extension);
				} else {
					return (type.startsWith('image/')
							|| [
								'application/pdf',
								'application/docx',
								'application/msword',
								'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
								'text/plain',
								'application/vnd.ms-excel',
								'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
								'text/csv'
							]
							.includes(type))
						&& (type !== 'image/svg+xml');
				}
			});
			return isValid;
		};

		document.querySelectorAll(`[data-required-from]`).forEach((checkbox) => {
			const data = checkbox.dataset.requiredFrom;
			const inputs = document.querySelectorAll(`[name="${data}"]`);
			if (inputs.length === 1) {
				inputs[0].addEventListener('change', function () {
					if (this.value.length > 0)
						checkbox.setAttribute('required', '');
					else
						checkbox.removeAttribute('required');
				});
			}
		});


		const validateForm = (form) => {
			// Get email field and recipients field (which cannot be of "email" type)
			const emailFields = form.querySelectorAll(`[type="email"]`);
			const phoneFields = form.querySelectorAll(`[type="tel"]`);
			const fileFields = form.querySelectorAll(`[type="file"]`);
			const nipFields = form.querySelectorAll(`[type="text"].nipInput`);
			const postalFields = form.querySelectorAll(`[type="text"].postal_codeInput`);

			let invalidElements = [];

			const validateException = (array, getFunc) => {
				array.forEach((field) => {
					//validate empty
					if (field.required && !field.value.trim().length) {
						invalidElements.push(field);
					}

					//validate email syntax
					if (field.value.trim().length && !getFunc(field.value.trim().toLowerCase())) {
						invalidElements.push(field);
					}
				});
			}


			validateException([...emailFields], validateEmail);
			validateException([...phoneFields], validatePhone);
			validateException([...nipFields], validateNip);
			validateException([...postalFields], validatePostalCode);


			[...fileFields].forEach((field) => {
				//validate empty
				if (field.required && !field.value) {
					invalidElements.push(field);
				}
				//validate file syntax
				if (field.value && !validateFile(field.files, field.accept)) {
					invalidElements.push(field);
				}
			});

			if (form.checkValidity() === false) {
				invalidElements = [
					...invalidElements,
					...form.querySelectorAll(':invalid:not(form):not(fieldset)'),
				];
				// Filter to get unique elements
				invalidElements = [...new Set(invalidElements)];
			}

			if (invalidElements.length) {
				invalidElements.forEach((invalidElement) => {
					const parent = invalidElement.parentElement.parentElement;
					let errorMessage = 'Invalid message.';
					switch (invalidElement.type) {
						case 'email':
							errorMessage = fhTranslate('email_error_message');
							break;
						case 'tel':
							errorMessage = fhTranslate('tel_error_message');
							break;
						case 'file':
							errorMessage = fhTranslate('file_error_message');
							break;
						default:
							errorMessage = fhTranslate('empty_error_message');
					}
					if (invalidElement.classList.contains('nipInput')) {
						errorMessage = fhTranslate('nip_error_message');
					} else if (invalidElement.classList.contains('postal_codeInput')) {
						errorMessage = fhTranslate('postal_error_message');
					}
					if (invalidElement.required && !invalidElement.value.trim().length)
						errorMessage = fhTranslate('empty_error_message');
					const errorMessageElement = parent.querySelector('.ErrorMessage');
					parent.classList.add('invalid');
					if (errorMessageElement) {
						invalidElement.classList.add('HasError');
						errorMessageElement.innerHTML = errorMessage;
					}
				});

				const invalidElementsScroll = form.querySelectorAll('.ErrorMessage');
				let elements = [];
				invalidElementsScroll.forEach((element) => {
					if (element.outerText !== '') {
						elements.push(element);
					}
				});
				elements[0].scrollIntoView({
					block: 'center',
					behavior: 'smooth'
				});

				return false;
			}

			return true;
		};

		const handleFormSubmit = (e) => {
			e.preventDefault();
			const form = e.target;
			form.querySelector('.formMessage').innerText = '';
			const submitButton = form.querySelector('button[type="submit"]');

			submitButton.disabled = true;
			// Clear all errors
			const invalidElementFieldsets = form.querySelectorAll('.invalid');
			form.querySelectorAll('.HasError').forEach((invalidElement) => invalidElement.classList.remove('HasError'));
			invalidElementFieldsets.forEach((fieldset) => {
				fieldset.classList.remove('invalid');
				const errorMessageElement = fieldset.querySelector('.ErrorMessage');
				if (errorMessageElement) {
					errorMessageElement.textContent = '';
				}
			});

			// Validate form
			const isValid = validateForm(form);
			if (isValid) {
				const url = fhGetConfig('ajax_url');
				const nonce = fhGetConfig('nonce');
				const captcha_site_key = '6LdirN0kAAAAACqthbJaVQ02sN9mxJTsJcHUwctv';

				form.querySelector('.formMessage').innerText = fhTranslate('loading_message');

				grecaptcha.ready(function () {
					grecaptcha
					.execute(captcha_site_key)
					.then(function (token) {
						const formData = new FormData(form);
						formData.append('nonce', nonce);
						formData.append('token', token);
						formData.append('action', 'custom_form_connection');
						form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
							formData.append(checkbox.getAttribute('name'), checkbox.checked ? 1 : 0);
						});

						fetch(url, {
							method: "post",
							body: formData,
						})
						.then((response) => {
							if (response.ok && response.status === 200) {
								return response.json();
							} else {
								form.querySelector('.formMessage').innerText = fhTranslate('error_message');
								console.error(`Something's gone wrong`, response);
							}
						})
						.then((result) => {
							if (result?.status === 'success') {
								const ratingValue = form.querySelector('.rating input:checked')?.value;
								form.reset();
								form.querySelector('.formMessage').innerText = fhTranslate('success_message');
								if (ratingValue) {
									submitButton.remove();
									form.querySelectorAll('.form-box').forEach(function (box) {
										if (Number(ratingValue) > 3 ) {
											form.querySelector('.google-form-link').classList.add('show');
										} else {
											form.querySelector('.thank-you-review').classList.add('show');
										}
									});
								}
							} else if (result?.status === 'file_failed') {
								const file_errors = result?.files_error;
								const clearFileErrors = form.querySelectorAll('input[type="file"] ~ .ErrorMessage');
								clearFileErrors.forEach(function (a) {
									a.innerHTML = '';
								})
								file_errors.forEach(element =>
									form.querySelector(`input[name="${element.input_name}[]"] ~ .ErrorMessage`).innerHTML += element.filename + ' ' + fhTranslate(element.error_file) + '<br>'
								);
							} else {
								form.querySelector('.formMessage').innerText = fhTranslate('error_message');
							}
							submitButton.disabled = false;
						})
						.catch((error) => {
							form.querySelector('.formMessage').innerText = fhTranslate('error_message');
							console.error('Error:', error);
						});
					});
				});
			} else {
				submitButton.disabled = false;
			}
		};

		$(formElement).on('submit', handleFormSubmit);

	});
})();
